const PUBLIC_HOLIDAY_CACHE_PREFIX = "uptaskPublicHolidays";

const fallbackIndianHolidays = (year) => [
  { date: `${year}-01-01`, name: "New Year's Day" },
  { date: `${year}-01-26`, name: "Republic Day" },
  { date: `${year}-08-15`, name: "Independence Day" },
  { date: `${year}-10-02`, name: "Gandhi Jayanti" },
  { date: `${year}-12-25`, name: "Christmas Day" },
];

const normalizePublicHoliday = (holiday) => ({
  id: `public-holiday-${holiday.date}-${holiday.name}`,
  type: "festival",
  eventType: "festival",
  event_date: `${holiday.date}T00:00:00`,
  event_date_key: holiday.date,
  readonly: true,
  title: holiday.localName || holiday.name,
  name: holiday.localName || holiday.name,
  meta: {
    display_name: holiday.localName || holiday.name,
    source: "Public holiday calendar",
  },
});

export const fetchIndianPublicHolidays = async (year = new Date().getFullYear()) => {
  const cacheKey = `${PUBLIC_HOLIDAY_CACHE_PREFIX}:${year}`;
  const cached = localStorage.getItem(cacheKey);

  if (cached) {
    try {
      return JSON.parse(cached);
    } catch {
      localStorage.removeItem(cacheKey);
    }
  }

  try {
    const response = await fetch(`https://date.nager.at/api/v3/PublicHolidays/${year}/IN`);
    if (!response.ok) throw new Error("Unable to fetch public holidays");

    const holidays = await response.json();
    const normalized = (holidays || []).map(normalizePublicHoliday);
    localStorage.setItem(cacheKey, JSON.stringify(normalized));
    return normalized;
  } catch {
    return fallbackIndianHolidays(year).map(normalizePublicHoliday);
  }
};

export const normalizeOfficeHoliday = (holiday) => {
  const date = String(holiday.holiday_date || holiday.date || "").slice(0, 10);

  return {
    id: `office-holiday-${holiday.id || date}`,
    type: "office_holiday",
    eventType: "office_holiday",
    event_date: `${date}T00:00:00`,
    event_date_key: date,
    readonly: true,
    title: holiday.title || "Office Holiday",
    name: holiday.title || "Office Holiday",
    meta: {
      display_name: holiday.title || "Office Holiday",
      description: holiday.description || "",
      source: "Office holiday",
    },
  };
};

export const currentMonthUpcomingOnly = (events = [], now = new Date()) => {
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);

  const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  monthEnd.setHours(23, 59, 59, 999);

  return events.filter((event) => {
    const date = new Date(event.event_date);
    if (Number.isNaN(date.getTime())) return false;
    return date >= today && date <= monthEnd;
  });
};
